

export const getDirectionPoints = (direction, width, height) => {
    switch (direction) {
      case 'horizontal':
        return [{ x: 0, y: 0 }, { x: width, y: 0 }];
      case 'vertical':
        return [{ x: 0, y: 0 }, { x: 0, y: height }];
      case 'diagonal':
      default:
        return [{ x: 0, y: 0 }, { x: width, y: height }];
    }
  };
